import React from 'react';
import { Link } from 'react-router-dom';
import BlogFooter from 'components/BlogFooter';
import BLOG_POSTS from './posts';
import styles from './styles.module.scss';

const Blogs = () => {
  const featuredPost = BLOG_POSTS.find(({ featured }) => featured);
  const otherPosts = BLOG_POSTS.filter(({ slug }) => slug !== featuredPost?.slug);

  return (
    <main className={styles.blogPage}>
      <header className={styles.navigation}>
        <div className={styles.navigationInner}>
          <Link className={styles.logo} to='/blog'>
            <span className={styles.logoMark}>?</span>
            <span>Trivia</span>
          </Link>
          <nav className={styles.navLinks} aria-label='Main navigation'>
            <a href='https://trytrivia.co/slack/'>Slack</a>
            <a href='https://trytrivia.co/microsoft-teams/'>Teams</a>
            <a href='https://trytrivia.co/'>Home</a>
            <Link className={styles.loginLink} to='/login'>
              Get started
            </Link>
          </nav>
        </div>
      </header>

      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <p className={styles.eyebrow}>The Trivia blog</p>
          <h1>Better team bonding, without another meeting.</h1>
          <p className={styles.heroText}>
            Ideas, playbooks, and practical advice for making hybrid work feel more human.
          </p>
        </div>
        <div className={styles.heroDecoration} aria-hidden='true'>
          <span>?</span>
          <span>✦</span>
        </div>
      </section>

      <section className={styles.content} aria-labelledby='latest-heading'>
        <div className={styles.sectionIntro}>
          <div>
            <p className={styles.eyebrow}>Latest from Trivia</p>
            <h2 id='latest-heading'>Ideas worth sharing with your team</h2>
          </div>
          <p>
            Short, practical reads for HR and People Ops teams building connection across Slack,
            Microsoft Teams, and everywhere work happens.
          </p>
        </div>

        {featuredPost && (
          <article className={styles.featuredCard}>
            <div className={styles.featuredImage}>
              <img src={featuredPost.image} alt={featuredPost.imageAlt} />
              <span className={styles.imageLabel}>Featured article</span>
            </div>
            <div className={styles.featuredCopy}>
              <p className={styles.postCategory}>{featuredPost.category}</p>
              <h3>{featuredPost.title}</h3>
              <p className={styles.excerpt}>{featuredPost.excerpt}</p>
              <div className={styles.postMeta}>
                <span>{featuredPost.author}</span>
                <span>{featuredPost.date}</span>
                <span>{featuredPost.readTime}</span>
              </div>
              <Link className={styles.readButton} to={`/blog/${featuredPost.slug}`}>
                Read the article <span aria-hidden='true'>↗</span>
              </Link>
            </div>
          </article>
        )}

        {otherPosts.length > 0 && (
          <div className={styles.articleGrid}>
            {otherPosts.map((post) => (
              <article className={styles.articleCard} key={post.slug}>
                <div className={styles.cardImage}>
                  <img src={post.image} alt={post.imageAlt} />
                </div>
                <div className={styles.cardContent}>
                  <p className={styles.postCategory}>{post.category}</p>
                  <h3>{post.title}</h3>
                  <p className={styles.excerpt}>{post.excerpt}</p>
                  <div className={styles.postMeta}>
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </div>
                  <Link className={styles.readButton} to={`/blog/${post.slug}`}>
                    Read the article <span aria-hidden='true'>↗</span>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>

      <section className={styles.cta} aria-labelledby='cta-heading'>
        <div>
          <p className={styles.eyebrow}>Make work more human</p>
          <h2 id='cta-heading'>Five-minute team bonding, right where work happens.</h2>
        </div>
        <div className={styles.ctaLinks}>
          <a href='https://trytrivia.co/slack/'>Try Trivia in Slack</a>
          <a href='https://trytrivia.co/microsoft-teams/'>Try Trivia in Teams</a>
        </div>
      </section>

      <BlogFooter />
    </main>
  );
};

export default Blogs;
